import { get, getOr, flow, map, flatten } from 'lodash/fp';
import { createSelector, createStructuredSelector } from 'reselect';
import { getMinMaxOptions, getYearOptions } from 'helpers/fieldOptions';

const DEFAULT_OPTIONS = [
  {
    fromYear: 2000,
    withReverse: true,
  },
  {
    fromYear: 1960,
    toYear: 2000,
    withReverse: true,
    step: 5,
  },
];

const getYearRangeOptions = createSelector(
  getOr(DEFAULT_OPTIONS, 'yearRangeOptions'),
  flow(map(getYearOptions), flatten),
);

const getOptions = createSelector(
  createStructuredSelector({
    options: getYearRangeOptions,
    compareValue: get(['compareValue']),
    type: get(['rangeType']),
  }),
  flow(({ options, compareValue, type }) =>
    type ? getMinMaxOptions({ options, compareValue, type }) : options,
  ),
);

export default {
  clearable: () => true,
  options: getOptions,
  placeholder: () => __('search.filters.any'),
};
